export class AppVersion {
public static appVersion = '1.2.88';
}
